
import { Navigate } from "react-router-dom";
import Profile from "@/pages/Profile";
import AccountSettings from "@/pages/profile/AccountSettings";
import PaymentMethods from "@/pages/profile/PaymentMethods";
import Notifications from "@/pages/profile/Notifications";
import HelpSupport from "@/pages/profile/HelpSupport";
import { RouteProps } from "@/types/routes";
import { RouteObject } from "react-router-dom";
import { AuthProtectedRoute } from "@/components/auth/AuthProtectedRoute";

export const profileRoutes = ({ session }: RouteProps): RouteObject[] => [
  {
    path: "/profile",
    element: <AuthProtectedRoute><Profile /></AuthProtectedRoute>
  },
  {
    path: "/profile/settings",
    element: <AuthProtectedRoute><AccountSettings /></AuthProtectedRoute>
  },
  {
    path: "/profile/payment",
    element: <AuthProtectedRoute><PaymentMethods /></AuthProtectedRoute>
  },
  {
    path: "/profile/notifications",
    element: <AuthProtectedRoute><Notifications /></AuthProtectedRoute>
  },
  {
    path: "/profile/help",
    element: <AuthProtectedRoute><HelpSupport /></AuthProtectedRoute>
  }
];
